import { useLayoutEffect, useRef, useState } from 'react';

/**
 * Keeps a document-flow spacer matched to the actual height of the fixed
 * domestic header. The header wraps (primary nav, sub-nav) as the viewport
 * narrows, so CSS-only spacer heights go stale and content slides underneath.
 */
export function useDomesticHeaderSpacer() {
  const headerRef = useRef(null);
  const [height, setHeight] = useState(null);

  useLayoutEffect(() => {
    const node = headerRef.current;
    if (!node) return undefined;

    const applyHeight = () => {
      const next = Math.ceil(node.getBoundingClientRect().height);
      if (next <= 0) return;
      setHeight((prev) => (prev === next ? prev : next));
    };

    applyHeight();

    let observer;
    if (typeof ResizeObserver !== 'undefined') {
      observer = new ResizeObserver(applyHeight);
      observer.observe(node);
    }

    window.addEventListener('resize', applyHeight);
    return () => {
      if (observer) observer.disconnect();
      window.removeEventListener('resize', applyHeight);
    };
  }, []);

  return {
    headerRef,
    spacerStyle: height != null ? { height: `${height}px` } : undefined,
  };
}
